import React from 'react';
import { Box, Typography } from '@mui/material';
import { useDirection } from '../../context/DirectionContext';
import { translate as tr } from '../../i18n/translations';

interface LanguageSwitcherProps {
  /** Use 'dark' inside the navy sidebar */
  variant?: 'light' | 'dark';
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ variant = 'light' }) => {
  const { lang, toggleLang } = useDirection();

  const dark = variant === 'dark';
  const borderColor  = dark ? '#1E293B' : 'rgba(0,0,0,0.12)';
  const activeColor  = dark ? '#F8FAFC' : '#1F1C16';
  const inactiveColor = dark ? '#475569' : '#9A8E72';

  return (
    <Box
      role="button"
      aria-label={tr('hdr.toggleLang', lang)}
      onClick={toggleLang}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '3px',
        border: `1px solid ${borderColor}`,
        px: '7px',
        py: '3px',
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'opacity 120ms',
        '&:hover': { opacity: 0.75 },
      }}
    >
      {(['en', 'he'] as const).map((l, i) => (
        <React.Fragment key={l}>
          {i > 0 && (
            <Typography component="span" sx={{ fontSize: 10, color: inactiveColor, mx: '1px' }}>|</Typography>
          )}
          <Typography
            component="span"
            sx={{
              fontSize: 10,
              fontWeight: lang === l ? 700 : 400,
              color: lang === l ? activeColor : inactiveColor,
              letterSpacing: '0.06em',
              lineHeight: 1,
            }}
          >
            {l.toUpperCase()}
          </Typography>
        </React.Fragment>
      ))}
    </Box>
  );
};

export default LanguageSwitcher;
